import { makeStyles, Theme } from '@material-ui/core/styles';
import { Layout } from "@roc/feature-app-core"
import { Paper, Tabs } from '@roc/ui';
import { observer } from "mobx-react"
import { ClosingTodayGrid } from './closingTodayGrid';
import { ClosingTomorrowGrid } from './closingTomorrowGrid';
import { FutureClosingsGrid } from './futureClosingsGrid';
import { useState } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: '1600px',
  },
  paper: {
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
    padding: '0px',
    borderRadius: '0 !important',
  },
}));

export const ClosingCoordinatorDashboard = observer(() => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);

  const TABS = [
    { label: 'Closing Today', },
    { label: 'Closing Tomorrow', },
    { label: 'Future Closings', },
  ];

  const CLOSING_TODAY = 0;
  const CLOSING_NEXT_BUSINESS_DAY = 1;
  const FUTURE_CLOSING = 2;

  const onTabChange = (e, index) => setSelectedTab(index);

  const renderTabContent = () => {
    switch (selectedTab) {
      case CLOSING_TODAY:
        return <ClosingTodayGrid />;
      case CLOSING_NEXT_BUSINESS_DAY:
        return <ClosingTomorrowGrid />;
      case FUTURE_CLOSING:
        return <FutureClosingsGrid />;
    }
  };

  return (
    <Layout containerClass={classes.container}>
      <Tabs
        tabs={TABS}
        selectedTab={selectedTab}
        onTabChange={onTabChange}
      />
      <Paper className={classes.paper}>
        {renderTabContent()}
      </Paper>
    </Layout>
  )
})
